/* eslint-disable @typescript-eslint/no-shadow */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslator } from '@jutro/locale';
import dwellingAnimals from '../DwellingAnimals/DwellingAnimals.jsx';
import metadata from './DwellingDetails.metadata.json5';
import styles from './DwellingDetails.module.scss'
import messages from './DwellingDetails.messages.js'

function DwellingDetails(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { yourHomeVM, updateSubmissionVM, findInvalidComponent, showErrors, onValidate, submissionVM, steps } = props;
    const [dwellingVM, setDwellingVM] = useState(yourHomeVM);
    const [yearOccupied, setYearOccupied] = useState(false);
    const [yearPurchased, setYearPurchased] = useState(false);
    const [dwellingUsage, setDwellingUsage] = useState(false);
    const [occupancy, setOccupancy] = useState(false);
    const [occupancyRelation, setOccupancyRelation] = useState(false);
    const [forSale, setForSale] = useState(true);
    const [renovRecov, setRenovRecov] = useState(true);
    const [condoLossCov, setCondoLossCov] = useState(false);
    const [unconventionalConstruct, setUnconventionalConstruct] = useState(false);
    const [dwellingFireplace, setDwellingFireplace] = useState(false);
    const [woodStoveExists, setWoodStoveExists] = useState(false);
    const [excessiveLiability, setExcessiveLiability] = useState(true);
    const [updateAnimalVM, setUpdateAnimalVM] = useState();
    const [occupancyAspectsValues, setOccupancyAspectsValues] = useState([]);
    const [occupancyReadOnly, setOccupancyReadOnly] = useState(false)
    const [usageMessage, setUsageMessage] = useState();
    const [occupancyMessage, setOccupancyMessage] = useState();
    const [atleastOneDogMsg, setAtleastOneDogMsg] = useState(false);
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const DWELLING_COMPONENT = 'DwellingDetails';
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(DWELLING_COMPONENT);
    const policyType = _.get(submissionVM, 'lobData.homeowners_tfpa.policyType_TWIA.value')
    const fireplaceExists =  _.get(dwellingVM, 'fireplaceExists_ext.value') 
    
    
    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, DWELLING_COMPONENT);
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        findInvalidComponent(isComponentValid, DWELLING_COMPONENT);
    }, [findInvalidComponent, isComponentValid])

    useEffect(() => {
        _.set(dwellingVM, 'policyType_Ext.value', policyType)
        setDwellingDetailsValues();
        occupancySelectedDetails();
    }, [])

    const setDwellingDetailsValues = useCallback(() => {
        const residenceTypeValue = _.get(dwellingVM, 'residenceType.aspects.availableValues[0]');

        switch (policyType.code) {
            case 'DP2':
                setYearPurchased(true);
                setDwellingUsage(true);
                setOccupancy(true);
                setOccupancyRelation(true);
                setExcessiveLiability(false);
                setUnconventionalConstruct(true);
                setDwellingFireplace(true);
                setWoodStoveExists(true);
                setUsageMessage(translator(messages.dwellingUsedAs));
                setOccupancyMessage(translator(messages.dwellingOccupancy));
                break;
            case 'HO4':
                setYearOccupied(true);
                setForSale(false);
                setRenovRecov(false);
                break;
            case 'HO6':
                if (!_.isUndefined(residenceTypeValue)) {
                    _.set(dwellingVM, 'residenceType.value', residenceTypeValue.code)
                }

                setYearPurchased(true);
                setDwellingUsage(true);
                setOccupancy(true);
                setOccupancyRelation(true);
                setCondoLossCov(true);
                setUsageMessage(translator(messages.condominiumUsedAs));
                setOccupancyMessage(translator(messages.condominiumOccupancy));
                break;
            case 'HO3':
                setYearPurchased(true);
                setDwellingUsage(true);
                setOccupancy(true);
                setUnconventionalConstruct(true);
                setDwellingFireplace(true);
                setWoodStoveExists(true);
                setUsageMessage(translator(messages.homeUsedAs));
                setOccupancyMessage(translator(messages.homeis));
                break;
            default:
        }

        updateSubmissionVM(dwellingVM);
    }, [])

    const occupancySelectedDetails = useCallback(() => {
        const dwellingUsageValue = _.get(dwellingVM, 'dwellingUsage.value.code');
        const occupancyAvailableValues = dwellingVM.occupancy.aspects.availableValues

        if (policyType.code === 'DP2' || policyType.code === 'HO6') {
            if (['sec', 'seas'].includes(dwellingUsageValue)) {
                _.remove(occupancyAvailableValues, { code: 'tenant' });
                setOccupancyReadOnly(false)
            }

            if (['prim'].includes(dwellingUsageValue)) {
                _.remove(occupancyAvailableValues, { code: 'tenant' });
                _.remove(occupancyAvailableValues, { code: 'nonown' });
                _.set(dwellingVM, 'occupancy.value', occupancyAvailableValues[0])
                setOccupancyReadOnly(true)
            }

            if (['rent'].includes(dwellingUsageValue)) {
                _.remove(occupancyAvailableValues, { code: 'owner' });
                _.remove(occupancyAvailableValues, { code: 'nonown' });
                _.set(dwellingVM, 'occupancy.value', occupancyAvailableValues[0])
                setOccupancyReadOnly(true)
            }
        }

        if (occupancyAvailableValues.length > 0) {
            const occupancyCodeClassList = occupancyAvailableValues.map((code) => {
                return {
                    code: code.code,
                    name: translator({ id: code.name })
                }
            })

            setOccupancyAspectsValues(occupancyCodeClassList);
        }
    }, [dwellingVM])

    const onClickAdd = useCallback(() => {
        const update = viewModelService.create(
            {},
            'pc',
            'org.tfpa.edge.capabilities.quote.submission.lob.homeowners.coverables.dto.DwellingAnimalDTO'
        );

        setUpdateAnimalVM(update);

        if (_.isUndefined(dwellingVM.value.dwellingAnimals)) {
            dwellingVM.value.dwellingAnimals = [];
            setAtleastOneDogMsg(true)
        }

        dwellingVM.value.dwellingAnimals.push({
            tempID: EntityUtil.nextId(),
            policyType: policyType.code
        });

        if (dwellingVM.value.dwellingAnimals.length > 0) {
            setAtleastOneDogMsg(false)
        }
    })

    const dwellingDeleteAnimals = useCallback((value) => {
        if (value.dwellingAnimals.value.length === 0) {
            setAtleastOneDogMsg(true)
        }

        updateSubmissionVM(value)
    })
    const [yearMessage, setYearMessage] = useState([]);

    const yearChange = useCallback(
        (value, path) => {
            _.set(dwellingVM, path, value);
            setYearMessage([]);
    
            if (value < 1800) {
                setYearMessage([translator(messages.yearMessageGreater)])
            }

            const currentYear = (new Date()).getFullYear();

            if (value > (currentYear)) {
                setYearMessage([translator(messages.yearMessage)])
            }
            updateSubmissionVM(dwellingVM)
        },
        [dwellingVM, updateSubmissionVM, translator]);

    const generateOverrides = useCallback(() => {
        if(!_.isUndefined(dwellingVM.dwellingAnimals)) {
        const overrides = dwellingVM.dwellingAnimals.children.map((_section, index) => ({
            [`dwellingAnimalsSection${index}`]: {
                animalVM: updateAnimalVM,
                isInvalid: findInvalidComponent,
                dwellingVM,
                dwellingDeleteAnimals,
                showErrors,
                onValidate
            },
        }));

        return Object.assign({}, ...overrides);
    }
    }, [dwellingDeleteAnimals, dwellingVM, findInvalidComponent, onValidate, showErrors, updateAnimalVM]);

    const writeValue = useCallback(
        (value, path) => {
            _.set(dwellingVM, path, value);
            setDwellingVM(dwellingVM);

            if((_.isUndefined(dwellingVM?.value?.dwellingAnimals)) && dwellingVM?.animalsInDwelling?.value === true) {
                setAtleastOneDogMsg(true);
            }

            occupancySelectedDetails();
            updateSubmissionVM(dwellingVM);
        }, [dwellingVM, updateSubmissionVM]
    );

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showRequired: true 
        },
        yearOccupied: {
            visible: yearOccupied,
            validationMessages: yearMessage,
            minYear: [1600]
        },
        petsOnPremises: {
            validationMessages: dwellingVM?.animalsInDwelling?.value === true && atleastOneDogMsg
                ? [translator(messages.atleastOneDog)] : [],
            required: true // DE17581
        },
        yearPurchased: {
            visible: yearPurchased,
            validationMessages: yearMessage,
            minYear: [1600],
            required: true // DE17581
        },
        residenceType: {
            readOnly: policyType.code === "HO6"
        },
        dwellingUsed: {
            visible: dwellingUsage,
            label: usageMessage
        },
        occupancy: {
            visible: occupancy,
            availableValues: occupancyAspectsValues,
            readOnly: occupancyReadOnly,
            label: occupancyMessage
        },
        occupancyRelationship: {
            visible: occupancyRelation && _.get(dwellingVM, 'occupancy.value.code') === 'nonown',
        },
        forSale: {
            visible: forSale,
            label: policyType.code === "HO6" ? translator(messages.condoForSale) : translator(messages.dwellingForSale)
        },
        unconventionalConstruct: {
            visible: unconventionalConstruct
        },
        dwellingFireplace: {
            visible: dwellingFireplace,
            label: policyType.code === "DP2" ? translator(messages.dwellingFirePlace) : translator(messages.Fireplace)
        },
        renovOrReconstruction: {
            visible: renovRecov,
            label: policyType.code === "HO6" ? translator(messages.condoRenov) : translator(messages.dwellingRenov)
        },
        condolessCoverage: {
            visible: condoLossCov
        },
        firePlaceNumber: {
            visible: fireplaceExists === true && policyType.code === "DP2" ||
                    fireplaceExists === true && policyType.code === "HO3"
        },
        renovOrRecDesc: {
            visible: _.get(dwellingVM, 'renovationOrReconst_ext.value') === true && policyType.code !== "HO4"
        },
        addButtonCont: {
            visible: dwellingVM?.animalsInDwelling?.value === true
        },
        primaryResCov: {
            visible: policyType.code === 'HO3' && ['sec', 'seas'].includes(_.get(dwellingVM, 'dwellingUsage.value.code'))
        },
        excessiveLiability: {
            visible: excessiveLiability
        },
        woodStoveExists: {
            visible: woodStoveExists,
            label: policyType.code === "DP2" ? translator(messages.dwellingWoodStove) : translator(messages.woodStove)
        },
        offerings: {
            visible: !_.isUndefined(dwellingVM.dwellingAnimals) && dwellingVM?.animalsInDwelling?.value === true,
            data: dwellingVM.dwellingAnimals ? dwellingVM.dwellingAnimals.children : []
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            dwellingAnimals: dwellingAnimals
        },
        resolveCallbackMap: {
            onClickAdd,
            dwellingDeleteAnimals,
            occupancySelectedDetails,
            yearChange
        },
    };

    return (

        <ViewModelForm
            uiProps={metadata.pageContent}
            model={dwellingVM}
            overrideProps={overrideProps}
            onValueChange={writeValue}
            // onModelChange={updateWizardData}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
        />

    );
}

DwellingDetails.propTypes = wizardProps;
export default DwellingDetails;
